import React from 'react'
import Banner from './components/Banner'
import { CustomButton } from 'styles/global'
import { Col, Row } from 'reactstrap'
import Navbar from 'components/Navbar'
import { CorpoConteudo } from 'layouts/simple/style'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const CreditoPessoal = () => {
  return (
    <>
      <Navbar />
      <CorpoConteudo minHeight="calc(100vh - 60px)">
        <Banner
          contentBanner={
            <div className="infos-credito-pessoal">
              <div className="container container-produto justify-content-center justify-content-lg-between">
                <div className="d-flex flex-column justify-content-center gap-5">
                  <h1>
                    Crédito Pessoal para
                    <br /> quem está sem margem
                  </h1>
                  <h2>
                    Até R$ 5.000,00 em 15 vezes, dinheiro <br /> na conta em até
                    24 horas.
                  </h2>
                  <div className="d-flex justify-content-center w-100">
                    <HashLink
                      to="/#iniciar-simulacao"
                      className="w-100 d-flex justify-content-center no-styled-link"
                      smooth
                      scroll={(el) => {
                        scrollWithOffset(el, 300)
                      }}
                    >
                      <CustomButton
                        background="var(--verde-riber)"
                        borderRadius={25}
                        height="56px"
                        fontSize="30px"
                        maxWidth="350px"
                        width="100%"
                      >
                        Simule agora
                      </CustomButton>
                    </HashLink>
                  </div>
                </div>
                <div className="d-lg-flex d-none flex-column justify-content-center w-600">
                  <img
                    className="img-banner-produto"
                    src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_pessoal_1.png"
                    alt=""
                  />
                  <Row className="d-flex row-gap-20">
                    <Col md={6}>
                      <div className="card-possibilidades">
                        <img
                          className="icon"
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_pessoal_2.png"
                          width={30}
                        />
                        <span>Parcele em até 15 vezes</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="card-possibilidades">
                        <img
                          className="icon"
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_pessoal_3.png"
                          width={30}
                        />
                        <span>Liberação rápida e 100% online</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="card-possibilidades">
                        <img
                          className="icon"
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_pessoal_4.png"
                          width={30}
                        />
                        <span>Dinheiro em até 24 horas</span>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="card-possibilidades">
                        <img
                          className="icon"
                          src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/credito_pessoal_5.png"
                          width={30}
                        />
                        <span>Disponível para negativados</span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          }
        />
      </CorpoConteudo>
    </>
  )
}

export default CreditoPessoal
